import React, { useRef, useMemo } from 'react';
import cn from 'classnames';
import { Button, Form, Grid, Input, Select, TextArea, View } from 'src/components/common';
import './styles.scss';
import { IRootState } from 'src/redux/rootReducer';
import { connect } from 'react-redux';
import { ErrorService, Yup } from 'src/services';
import { Formik, FormikProps } from 'formik';
import { useEffect } from 'react';
import { PhaseInfo, PhaseModalTypes } from 'src/redux/phasecodes/types';
import { addPhaseAsync, updatePhaseAsync } from 'src/redux/phasecodes/actions';
import { CustomModal } from 'src/components/Modal';

const PhaseSchema = Yup.object().shape({
  code: Yup.string()
    // .typeError(phaseCodeError)
    .test(
      'len',
      ErrorService.MESSAGES.invalidPhaseCode,
      val => (val?.toString()?.length || 0) === 5 && !val.match(/\D/i),
    )
    .required(),
  description: Yup.string().max(255, ErrorService.MESSAGES.descriptionMaxLength).required(),
  status: Yup.string().typeError(ErrorService.MESSAGES.required).required(),
});

const PhasesModal: React.FC<Props> = ({ loading, data, openModalType, onClose, status, onUpdatePhase, onAddPhase }) => {
  const formRef = useRef<FormikProps<PhaseInfo>>(null);

  useEffect(() => {}, [data]);

  const handleSubmit = (value: PhaseInfo) => {
    if (openModalType === PhaseModalTypes.ADD) onAddPhase(value);
    if (openModalType === PhaseModalTypes.EDIT) onUpdatePhase(value);
  };

  const renderTitle = () => {
    // console.log(openModalType);
    switch (openModalType) {
      case PhaseModalTypes.EDIT:
        return <h3>Edit Phase Code</h3>;
      case PhaseModalTypes.ADD:
        return <h3>Add Phase Code</h3>;
    }
  };

  const renderBody = useMemo(() => {
    return (
      <Formik
        key={`formik-type-${data.code}-${openModalType}`}
        initialValues={data}
        onSubmit={handleSubmit}
        validationSchema={PhaseSchema}
        innerRef={formRef}>
        {({ handleSubmit, errors, touched, getFieldProps, setFieldValue, setFieldTouched }) => (
          <Form preventDefault autoComplete="off" className="ctn-uam__form">
            <Grid.Wrap>
              <Grid.Item>
                <Input
                  label="Code *"
                  placeholder="Code"
                  errorMessage={touched.code ? errors.code : ''}
                  {...getFieldProps('code')}
                  disabled={openModalType === PhaseModalTypes.EDIT}
                />
              </Grid.Item>
              <Grid.Item>
                <Select
                  creatable={false}
                  options={status || []}
                  label="Status *"
                  placeholder="Choose Here ..."
                  errorMessage={touched.status ? errors.status : ''}
                  {...getFieldProps('status')}
                  name="status"
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                />
              </Grid.Item>
              <Grid.Item>
                <TextArea
                  label="Description *"
                  placeholder="Description"
                  errorMessage={touched.description ? errors.description : ''}
                  {...getFieldProps('description')}
                />
              </Grid.Item>
            </Grid.Wrap>
            <View className={cn('ctn-phasecodes-modal__footer')}>
              <View flexGrow={1} justify={'flex-end'} isRow className={'mt-32'}>
                <Button label={'CANCEL'} onClick={onClose} className={cn('mr-5')} variant={'outline'} type={'button'} />
                <Button type={'button'} onClick={() => handleSubmit()} isLoading={loading}>
                  {openModalType === PhaseModalTypes.EDIT ? 'UPDATE' : 'ADD'}
                </Button>
              </View>
            </View>
          </Form>
        )}
      </Formik>
    );
    // eslint-disable-next-line
  }, [data, loading, openModalType]);

  return <CustomModal openModalType={openModalType} header={renderTitle()} body={renderBody} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose?: () => void;
  };

const mapStateToProps = (state: IRootState) => ({
  data: state.phaseCodes.selectedPhase,
  loading: state.phaseCodes.isLoading,
  status: state.content.status,
  openModalType: state.phaseCodes.openModalType,
});

const mapDispatchToProps = {
  onUpdatePhase: updatePhaseAsync.request,
  onAddPhase: addPhaseAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhasesModal);
